import {
  SET_TEAM_SETTING_OVERRIDE_UI_FLAG,
  SET_TEAM_SETTING_OVERRIDE,
  DELETE_TEAM_SETTING_OVERRIDE,
} from './types';
import TeamSettingOverridesAPI from '../../../api/teamSettingOverrides';

export const actions = {
  show: async ({ commit }, teamId) => {
    commit(SET_TEAM_SETTING_OVERRIDE_UI_FLAG, { isFetching: true });
    try {
      const response = await TeamSettingOverridesAPI.show(teamId);
      // Backend returns 204 (no content) when there's no override.
      const data =
        response.status === 204 || !response.data ? null : response.data;
      commit(SET_TEAM_SETTING_OVERRIDE, { teamId, data });
      return data;
    } finally {
      commit(SET_TEAM_SETTING_OVERRIDE_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, { teamId, ...payload }) => {
    commit(SET_TEAM_SETTING_OVERRIDE_UI_FLAG, { isCreating: true });
    try {
      const response = await TeamSettingOverridesAPI.create(teamId, payload);
      commit(SET_TEAM_SETTING_OVERRIDE, { teamId, data: response.data });
      return response.data;
    } finally {
      commit(SET_TEAM_SETTING_OVERRIDE_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { teamId, ...payload }) => {
    commit(SET_TEAM_SETTING_OVERRIDE_UI_FLAG, { isUpdating: true });
    try {
      const response = await TeamSettingOverridesAPI.update(teamId, payload);
      commit(SET_TEAM_SETTING_OVERRIDE, { teamId, data: response.data });
      return response.data;
    } finally {
      commit(SET_TEAM_SETTING_OVERRIDE_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, teamId) => {
    commit(SET_TEAM_SETTING_OVERRIDE_UI_FLAG, { isDeleting: true });
    try {
      await TeamSettingOverridesAPI.delete(teamId);
      commit(DELETE_TEAM_SETTING_OVERRIDE, teamId);
    } finally {
      commit(SET_TEAM_SETTING_OVERRIDE_UI_FLAG, { isDeleting: false });
    }
  },
};
